var exports = {
  "k": "x31de4314--058083--container",
  "K": "x31de4314--058083--icon",
};

module.exports = exports;
